var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelenAmio2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_16_1164)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_linear_16_1164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 20H13.168V15.9629H8.66797V20H7.67188V11.4336H8.66797V15.084H13.168V11.4336H14.1641V20ZM21.8926 20L20.8379 17.2812H17.4043L16.3555 20H15.3477L18.6992 11.3984H19.5957L22.9238 20H21.8926ZM20.5391 16.3965L19.5371 13.6953C19.5137 13.625 19.4746 13.5098 19.4199 13.3496C19.3691 13.1895 19.3164 13.0234 19.2617 12.8516C19.207 12.6797 19.1621 12.541 19.127 12.4355C19.0879 12.5957 19.0449 12.7559 18.998 12.916C18.9551 13.0723 18.9121 13.2188 18.8691 13.3555C18.8262 13.4883 18.7891 13.6016 18.7578 13.6953L17.7383 16.3965H20.5391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_16_1164",
    x: -40,
    y: -40,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_16_1164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_16_1164",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_1164",
    x1: 0,
    y1: 0,
    x2: 30,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9B4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelenAmio2);
export default __webpack_public_path__ + "static/media/Helen-Amio-2.bcca37c7eaa48943a3b012782ceb385f.svg";
export { ForwardRef as ReactComponent };